export const FileFields = {
    Descripcion: 'descripcionArchivo',
    Nombre: 'nombreArchivo',
    CodPath: 'codPathFile',
    PathFisico: 'pathFisico',
    PathVirtual: 'pathVirtual'
} as const

export const FilePutFields = {
    CodPais: 'codPais',
    CodArchivoTipo: 'codArchivoTipo',
    TieneArchivoFisico: 'tieneArchivoFisico',
    File: 'file',
    Observaciones: 'observaciones'
} as const
